import { headerScript } from "./_headerScript";
import { swiper } from "./_swiper";
import { tabScroll } from "./_tabScroll";
import { tab } from "./_tab";
import { serviceTab } from "./_tab";
import { dropdown } from "./_dropdown";
import { animation } from "./_animation";
import { anchorScroll } from "./_anchorScroll";
import { fvHeadingAnime } from "./_textAnime";
import { headingAnime } from "./_textAnime";
import { textAnime } from "./_textAnime";
import { fvMovieLoop } from "./_fvMovieLoop";
import { reload } from "./_reload";
// ページの内容が完全に読み込まれた後のイベント
document.addEventListener('DOMContentLoaded', () => {
    // メインタグのID取得
    const mainElement = document.querySelector('main');
    const pageId = mainElement ? mainElement.getAttribute('id') : null;

    // ページ固有の関数実行
    const pageFunctions = {
        'top': [tab ,fvHeadingAnime, fvMovieLoop],
        'service': [serviceTab],
    };
    
    
    // 見出しのアニメーション
    headingAnime();
    textAnime();
    // dropdownは常に実行
    dropdown();
    // animationは常に実行
    animation();
    // headerScriptは常に実行
    headerScript();
    // swiperは常に実行
    swiper();
    // スクロールのドラッグ有効化
    tabScroll();
    // アンカースクロール
    anchorScroll();
    // リロード
    reload();



    // ページ固有の関数を実行
    if (pageId && pageFunctions[pageId]) {
        pageFunctions[pageId].forEach(fn => {
            if (typeof fn === 'function') {
                try {
                    fn();
                } catch (error) {
                    console.error(`ページID ${pageId} の関数実行中にエラーが発生しました:`, error);
                }
            } else {
                console.error(`ページID ${pageId} に対して関数が期待されましたが、${typeof fn} が得られました`);
            }
        });
    }
});

